/**
 * Turns an axios/fetch error into a message a person can act on.
 *
 * Before this, every list page caught errors by quietly setting its data
 * to [] — so with no internet the page said "No customers found" /
 * "No operators found", which looks like the data is gone.
 */

export const isOffline = () => typeof navigator !== "undefined" && navigator.onLine === false;

/** True when the request never got an answer (no internet, server down, timeout, CORS). */
export const isNetworkError = (err) =>
  isOffline() ||
  !!err && (
    err.code === "ERR_NETWORK" ||
    err.code === "ECONNABORTED" ||
    err.code === "ETIMEDOUT" ||
    err.message === "Network Error" ||
    (err.request && !err.response)
  );

export const getErrorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  if (isOffline()) return "You're offline. Check your internet connection and try again.";
  if (err && (err.code === "ECONNABORTED" || err.code === "ETIMEDOUT")) {
    return "The server took too long to respond. Please try again.";
  }
  if (isNetworkError(err)) {
    return "Can't reach the server. Check your internet connection and try again.";
  }
  const data = err?.response?.data;
  return (data && (data.message || data.error)) || err?.message || fallback;
};
